import { createCrudSlice } from './createCrudSlice';
import { commercialApi } from '../../services/api';

const { reducer, actions } = createCrudSlice('commercial', commercialApi);

export const {
  fetchAll: fetchCommercial,
  fetchById: fetchCommercialById,
  create: createCommercial,
  update: updateCommercial,
  remove: deleteCommercial,
  clearError,
  clearCurrentItem,
} = actions;

export default reducer;
